module.exports = __webpack_public_path__ + "static/slider_1-194e95bc2b52e1be1b974f1f65774012.jpg";